import { COMPONENTS, EVENTS } from '../../lib/constants';
import { GameConfigs } from '../../lib/globals/GameConfigs';
import HELPERS from '../../lib/globals/helpers/Helpers';
import { BonusGameFinishedView } from '../../view/bonus-game/BonusGameFinished';
import MainGridController from '../../controllers/grid/MainGridController';
import { MainViewGrid } from '../../view/MainViewGrid';
import { FreespinStatusbarView } from '../../view/freespin/FreespinStatusbarView';
import { FreespinWinView } from '../../view/freespin/FreespinWinView';

export default function handleBonusRound(msg, that) {
	if (GameConfigs.uiComponent[COMPONENTS.BONUS_GAME_DIALOGUE]) {
		GameConfigs.uiComponent.removeView(
			GameConfigs.uiComponent[COMPONENTS.BONUS_GAME_DIALOGUE]
		);
	}
	if (
		msg === 'started' &&
		GameConfigs.uiComponent[COMPONENTS.BONUS_GAME] === undefined
	) {
		if (GameConfigs.doubleChance) {
			HELPERS.dispatchCustomEvent(EVENTS.DOUBLE_CHANCE, {
				doubleChance: false
			});
			GameConfigs.doubleChance = false;
		}
		// GameConfigs.bonusBuy = false;
		window.sm.stop('bg_music_lvl2', 1500);
		window.sm.stop('bg_music_lvl1', 1500);
		that.bgMusic_idle = false;
		that.bgMusic_in_game = false;
		if (!that.bgMusic_bonus) {
			window.sm.play({
				name: 'bg_music_lvl3',
				loop: true,
				background: true,
				fade: 300
			});
			that.bgMusic_bonus = true;
		}
		that.viewTransitions.addBonusRoundViews();
		//where i am removing idle views?
	}
	if (msg === 'finished') {
		window.sm.stop('bg_music_lvl3', 500);
		that.bgMusic_bonus = false;
		// window.sm.play({ name: "bg_music_lvl4_v2", loop: true });
		GameConfigs.modal = 'bonus_game_finish';
		HELPERS.dispatchCustomEvent(EVENTS.MODAL, { modal: 'bonus_game_finish' });
		GameConfigs.uiComponent.addView(BonusGameFinishedView);
	}
	if (msg === '') {
		GameConfigs.bonusBuy = false;
		that.viewTransitions.addIdleGameViews();
		that.viewTransitions.removeBonusView();
		window.sm.stop('bg_music_lvl3', 500);
		window.sm.play({
			name: 'bg_music_lvl1',
			loop: true,
			background: true,
			fade: 500
		});
		that.bgMusic_idle = true;
		that.bgMusic_in_game = false;
		that.bgMusic_bonus = false;
		GameConfigs.uiComponent.gridController = new MainGridController(
			GameConfigs.uiComponent,
			MainViewGrid
		);
		GameConfigs.uiComponent.resize(window.CurrentSize.w, window.CurrentSize.h);
		GameConfigs.reelComponent.resetBonus();
		if (GameConfigs.bonusRestore) {
			GameConfigs.bonusRestore = null;
		}
		if (GameConfigs.bonusRoundData) {
			GameConfigs.bonusRoundData = null;
		}
		if (GameConfigs.bonusRoundInfo) {
			GameConfigs.bonusRoundInfo = null;
		}

		if (GameConfigs.isFreeSpin) {
			HELPERS.dispatchCustomEvent(EVENTS.FREESPIN, {
				freespin: { ...GameConfigs.freeSpinLocal, hasBonus: false }
			});
			GameConfigs.freeSpinLocal = {
				...GameConfigs.freeSpinLocal,
				hasBonus: false
			};
			if (
				GameConfigs.freeSpinLocal.status === 'active' &&
				GameConfigs.freeSpinLocal.count > 0
			) {
				GameConfigs.uiComponent.addView(FreespinStatusbarView);
				let disabled = {
					bonus_widget: true,
					double_widget: true,
					info: false,
					settings: false,
					spin: false,
					auto: false,
					fast: false,
					quest_widget: true,
					bet_amount: true
				};
				GameConfigs.disabled = disabled;
				HELPERS.dispatchCustomEvent(EVENTS.IS_DISABLED, { disable: disabled });
				// HELPERS.disableAllButtons(false);
				if (GameConfigs.autospin.pause) {
					GameConfigs.autospin.isAutoOn = true;
				}
			} else {
				GameConfigs.uiComponent.addView(FreespinWinView);
				HELPERS.dispatchCustomEvent(EVENTS.MODAL, { modal: 'freespin_win' });
				HELPERS.disableAllButtons(true);
			}
		} else {
			if (GameConfigs.autospin.pause) {
				GameConfigs.autospin.isAutoOn = true;
			}

			HELPERS.disableAllButtons(false);
		}
	}
}
